import { Skeleton } from "@/components/ui/skeleton"

/**
 * OKS-51 — Loading skeleton for the rankings area.
 *
 * UX Spec §3: skeleton matches the populated layout — one skeleton
 * podium block (3 podium-shaped placeholders) + 7 skeleton list rows
 * below. The filter switch (LeaderboardTabs) is NOT skeletonised; it
 * stays interactive during partial reload (switching during load
 * cancels the in-flight visit per Inertia's coalesce behaviour).
 *
 * Self-row pin skeleton is intentionally omitted in V1 — the BE
 * doesn't expose a "self_pin will appear" hint on the in-flight
 * request, and rendering one speculatively would flicker. The pin
 * appears server-paint after the visit lands.
 *
 * `aria-busy="true"` so SRs don't announce stale content during the
 * skeleton render (UX Spec §6).
 */
export function LeaderboardSkeleton() {
  return (
    <div
      aria-busy="true"
      data-testid="leaderboard-skeleton"
      className="flex flex-col gap-3"
    >
      <div className="flex items-end justify-center gap-3 pt-2 pb-3">
        <Skeleton className="size-12 rounded-full" />
        <Skeleton className="size-16 rounded-full" />
        <Skeleton className="size-11 rounded-full" />
      </div>
      <ul className="flex flex-col gap-2">
        {Array.from({ length: 7 }).map((_, i) => (
          <li key={i} className="flex items-center gap-3 px-3 py-2">
            <Skeleton className="size-6 rounded-sm" />
            <Skeleton className="size-8 rounded-full" />
            <Skeleton className="h-4 flex-1" />
            {/* OKS-394 — trend-cell placeholder, matches populated row layout. */}
            <Skeleton className="size-4 shrink-0 rounded-sm" />
            <Skeleton className="h-4 w-16" />
          </li>
        ))}
      </ul>
    </div>
  )
}
